import { TagFragment } from '~/graphql/fragments'
import {
  SectionAbout,
  SectionArticles,
  SectionAwards,
  SectionCanvas,
  SectionClients,
  SectionContactForm,
  SectionCta,
  SectionFacts,
  SectionFaq,
  SectionFeatures,
  SectionGames,
  SectionHero,
  SectionHome,
  SectionImageGallery,
  SectionJobs,
  SectionLetsTalk,
  SectionLogos,
  SectionMedia,
  SectionMediaLarge,
  SectionNewsletterSubscription,
  SectionNumbers,
  SectionProjects,
  SectionReel,
  SectionRelatedArticles,
  SectionServices,
  SectionStatement,
  SectionStructuredText,
  SectionTeam,
  SectionTeaser,
  SectionTestimonials,
  SectionVideo,
  SectionContactUs
} from '~/graphql/sections'
import { graphql } from '~/lib/datocms/graphql'

export const queryIndex = graphql(
  /* GraphQL */ `
    query Index {
      index {
        _seoMetaTags {
          ...TagFragment
        }
        _modelApiKey
        title
        modules {
          ... on RecordInterface {
            id
            __typename
          }
          ...SectionAbout
          ...SectionArticles
          ...SectionAwards
          ...SectionCanvas
          ...SectionClients
          ...SectionContactForm
          ...SectionCta
          ...SectionFacts
          ...SectionFaq
          ...SectionFeatures
          ...SectionGames
          ...SectionHero
          ...SectionHome
          ...SectionImageGallery
          ...SectionJobs
          ...SectionLetsTalk
          ...SectionLogos
          ...SectionMedia
          ...SectionMediaLarge
          ...SectionNewsletterSubscription
          ...SectionNumbers
          ...SectionProjects
          ...SectionReel
          ...SectionRelatedArticles
          ...SectionServices
          ...SectionStatement
          ...SectionStructuredText
          ...SectionTeam
          ...SectionTeaser
          ...SectionTestimonials
          ...SectionVideo
          ...SectionContactUs
        }
      }
    }
  `,
  [
    TagFragment,
    SectionAbout,
    SectionArticles,
    SectionAwards,
    SectionCanvas,
    SectionClients,
    SectionContactForm,
    SectionCta,
    SectionFacts,
    SectionFaq,
    SectionFeatures,
    SectionHero,
    SectionHome,
    SectionGames,
    SectionImageGallery,
    SectionJobs,
    SectionLetsTalk,
    SectionLogos,
    SectionMedia,
    SectionMediaLarge,
    SectionNewsletterSubscription,
    SectionNumbers,
    SectionProjects,
    SectionReel,
    SectionRelatedArticles,
    SectionServices,
    SectionStatement,
    SectionStructuredText,
    SectionTeam,
    SectionTeaser,
    SectionTestimonials,
    SectionVideo,
    SectionContactUs
  ]
)
